'use strict'

import $ from 'jquery'
import axios from 'axios'

let baseUrl = '/'
const handledRoutes = {
  // Address Type
  AddressTypeController: 'admin/maintenance/addressType',
  AddressTypeApiController: 'api/admin/maintenance/addressType',
  // Owner
  OwnerController: 'admin/maintenance/owner',
  OwnerApiController: 'api/admin/maintenance/owner',
  // Eligibility
  EligibilityController: 'admin/maintenance/eligibility',
  EligibilityApiController: 'api/admin/maintenance/eligibility',
  // Race
  RaceController: 'admin/maintenance/race',
  RaceApiController: 'api/admin/maintenance/race',
  // Sport
  SportController: 'admin/maintenance/sport',
  SportApiController: 'api/admin/maintenance/sport',
  // Title
  TitleController: 'admin/maintenance/title',
  TitleApiController: 'api/admin/maintenance/title',
  // Member Type
  TypeController: 'admin/maintenance/type',
  TypeApiController: 'api/admin/maintenance/type',
  // Citizenship
  CitizenshipController: 'admin/maintenance/citizenship',
  CitizenshipApiController: 'api/admin/maintenance/citizenship',
  // Current Year
  CurrentYearController: 'admin/maintenance/currentYear',
  CurrentYearApiController: 'api/admin/maintenance/currentYear',
  // Division
  DivisionController: 'admin/maintenance/division',
  DivisionApiController: 'api/admin/maintenance/division',
  // Sport Region
  SportRegionController: 'admin/maintenance/sportRegion',
  SportRegionApiController: 'api/admin/maintenance/sportRegion',
  // Common Data for drop downs
  CommonDataApiController: 'api/common',
  // Online Directory APIs
  DirectoryApiController: 'api/directory',
  DirectoryDetailController: 'orgDetail',
  DirectoryMemberListController: 'memberList',
  // Change Request APIs
  ChangeRequestApiController: 'api/changeRequest',
  ChangeRequestAdminApiController: 'api/admin/changeRequest',
  ChangeRequestController: 'changeRequest',
  ChangeRequestAdminController: 'admin/changeRequest',
  // Member Org APIs
  MemberOrgApiController: 'api/org',
  MemberOrgAdminApiController: 'api/admin/org',
  MemberOrgAdminController: 'admin/org',
  // Member Person URLs
  MemberPersonAdminController: 'admin/person',
  MemberPersonAdminApiController: 'api/admin/person',
  PersonLookupController: 'personLookup',
  // Salesforce Admin URLs
  SalesForceAdminApiController: 'api/admin/salesforce',
  SalesForceAdminController: 'admin/salesforce',
  // Member Sport URLs
  MemberSportAdminController: 'admin/sport',
  MemberSportAdminApiController: 'api/admin/sport',
  // Sport Sponsorship URLs
  SportsSponsorshipApiController: 'api/ss',
  AddressApiController: 'api/admin/address'
}

/***
 * Returns the base url for the site
 * @returns {String}
 */
function getContextRoot () {
  const defaultRoot = ''
  // Defined in header HTML.
  let baseElement = document.getElementById('contextRoot')
  if (baseElement === null || baseElement.getAttribute('data-context-root') === null) {
    return defaultRoot
  }
  // else
  return baseElement.getAttribute('data-context-root')
}

function get (routeString) {
  return `${baseUrl}${routeString}`
}
/**
 * Adds the CSRF token all ajax requests
 * https://docs.spring.io/spring-security/site/docs/current/reference/html/csrf.html#csrf-include-csrf-token-ajax
 */
function addCSRFHeader () {
  let token = $('meta[name=\'_csrf\']').attr('content')
  let header = $('meta[name=\'_csrf_header\']').attr('content')

  // jquery ajax setup
  $.ajaxSetup({
    dataType: 'json',
    contentType: 'application/json',
    beforeSend: function (xhr) {
      xhr.setRequestHeader(header, token)
    },
    // handle responses with empty body.  Otherwise $.ajax fails on parsing the response
    dataFilter: function (data, type) {
      if (type === 'json' && data === '') {
        data = null
      }
      return data
    }
  })

  // axios ajax setup
  axios.defaults.headers.common[header] = token
}

document.addEventListener('DOMContentLoaded', function () {
  baseUrl = getContextRoot()
  addCSRFHeader()
})

export default {
  // Address Type URLs
  addressTypeController: get.bind(this, [handledRoutes.AddressTypeController]),
  addressTypeApiController: get.bind(this, [handledRoutes.AddressTypeApiController]),
  // Owner URLs
  ownerController: get.bind(this, [handledRoutes.OwnerController]),
  ownerApiController: get.bind(this, [handledRoutes.OwnerApiController]),
  // Eligibility URLs
  eligibilityController: get.bind(this, [handledRoutes.EligibilityController]),
  eligibilityApiController: get.bind(this, [handledRoutes.EligibilityApiController]),
  // Race URLs
  raceController: get.bind(this, [handledRoutes.RaceController]),
  raceApiController: get.bind(this, [handledRoutes.RaceApiController]),
  // Sport URLs
  sportController: get.bind(this, [handledRoutes.SportController]),
  sportApiController: get.bind(this, [handledRoutes.SportApiController]),
  // Title URLs
  titleController: get.bind(this, [handledRoutes.TitleController]),
  titleApiController: get.bind(this, [handledRoutes.TitleApiController]),
  // Member Type URLs
  typeController: get.bind(this, [handledRoutes.TypeController]),
  typeApiController: get.bind(this, [handledRoutes.TypeApiController]),
  // Citizenship URLs
  citizenshipController: get.bind(this, [handledRoutes.CitizenshipController]),
  citizenshipApiController: get.bind(this, [handledRoutes.CitizenshipApiController]),
  // Current Year URLs
  currentYearController: get.bind(this, [handledRoutes.CurrentYearController]),
  currentYearApiController: get.bind(this, [handledRoutes.CurrentYearApiController]),
  // Division URLs
  divisionController: get.bind(this, [handledRoutes.DivisionController]),
  divisionApiController: get.bind(this, [handledRoutes.DivisionApiController]),
  // Sport Region URLs
  sportRegionController: get.bind(this, [handledRoutes.SportRegionController]),
  sportRegionApiController: get.bind(this, [handledRoutes.SportRegionApiController]),
  // Common Data URLs
  commonDataApiController: get.bind(this, [handledRoutes.CommonDataApiController]),
  // Directory URLs
  directoryApiController: get.bind(this, [handledRoutes.DirectoryApiController]),
  directoryDetailController: get.bind(this, [handledRoutes.DirectoryDetailController]),
  directoryMemberListController: get.bind(this, [handledRoutes.DirectoryMemberListController]),
  // Change Request URLs
  changeRequestApiController: get.bind(this, [handledRoutes.ChangeRequestApiController]),
  changeRequestAdminApiController: get.bind(this, [handledRoutes.ChangeRequestAdminApiController]),
  changeRequestController: get.bind(this, [handledRoutes.ChangeRequestController]),
  changeRequestAdminController: get.bind(this, [handledRoutes.ChangeRequestAdminController]),
  // Member Org URLs
  memberOrgApiController: get.bind(this, [handledRoutes.MemberOrgApiController]),
  memberOrgAdminApiController: get.bind(this, [handledRoutes.MemberOrgAdminApiController]),
  memberOrgAdminController: get.bind(this, [handledRoutes.MemberOrgAdminController]),
  // Member Person URLs
  memberPersonAdminController: get.bind(this, [handledRoutes.MemberPersonAdminController]),
  memberPersonAdminApiController: get.bind(this, [handledRoutes.MemberPersonAdminApiController]),
  personLookupController: get.bind(this, [handledRoutes.PersonLookupController]),
  // Salesforce Admin
  salesForceAdminApiController: get.bind(this, [handledRoutes.SalesForceAdminApiController]),
  salesForceAdminController: get.bind(this, [handledRoutes.SalesForceAdminController]),
  // Member Sport URLs
  memberSportAdminController: get.bind(this, [handledRoutes.MemberSportAdminController]),
  memberSportAdminApiController: get.bind(this, [handledRoutes.MemberSportAdminApiController]),

  // Sport Sponsorship URLs
  // SportsSponsorshipApiController: 'api/ss'
  sportsSponsorshipApiController: get.bind(this, [handledRoutes.SportsSponsorshipApiController]),
  addressApiController: get.bind(this, [handledRoutes.AddressApiController]),

  getContextRoot: getContextRoot
}



// WEBPACK FOOTER //
// ./src/js/endpoints/Urls.js